<template>
  <div>
    <transition name="vue-table-loader">
      <div class="vue-details-loader alt" v-if="loading">
        <span class="fa fa-cog fa-spin fa-1x"></span>
      </div>
    </transition>
    <div>
      <div class="row mt-2 pb-0">
        <div
          class="col-md-7 clearfix d-flex align-items-center justify-content-start"
        >
          <h4 class="m-0">Assets</h4>
        </div>
        <div class="col-md-5 d-flex align-items-center justify-content-end">
          <button
            class="btn btn-outline-secondary mr-2"
            @click="uiStates.bulkUploadModal = true"
            data-id="bulk-asset-toggle"
          >
            Bulk Upload
          </button>
          <button
            class="btn btn-outline-primary"
            @click="uiStates.createAssetModal = true"
            data-id="asset-upload-toggle"
          >
            Add Asset
          </button>
        </div>
      </div>
      <div class="row mt-4 pb-2">
        <div class="col-md-4">
          <base-filter-bar placeholder="Search Assets" class="mb-0 dam-search"></base-filter-bar>
        </div>
        <div class="col-md-8">
            <base-select-visible :per-page="perPage" :amounts-shown="amountsShown"></base-select-visible>
        </div>
      </div>
      <transition name="fade">
        <div v-if="uiStates.createAssetModal" class="modal-wrapper">
          <div
            class="modal-bg"
            @click="handleCloseCreateAssetModal"
          ></div>
          <div class="d-flex flex-column modal-inner p-4">
            <div class="d-flex align-items-center mb-5">
              <h4 class="mr-2">
                Add Assets 
              </h4>
              <div class="text-muted">
                Max 20 files per upload
              </div>
            </div>
            <div class="d-flex flex-column align-items-start">
              <input data-id="asset-upload-file" type="file" ref="file" multiple="multiple" class="mb-2" />
            </div>
            <div class="d-flex flex-column align-items-start">
              <label for="private">Private</label>
              <input type="checkbox"
                name="private"
                data-id="asset-upload-private"
                style="width: 38px; height: 38px;"
                v-model="createAssetModal.private"
                class="mb-2 form-control form-private"
              />
            </div>
            <div v-if="this.uiStates.createAssetModalWarning" class="text-danger mb-2">
              Too many files, please select fewer
            </div>
            <button data-id="asset-upload-submit" class="btn my-2 btn-primary" :disabled="loading" @click="handleUploadFiles()">
              Submit
            </button>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div v-if="uiStates.bulkUploadModal" class="modal-wrapper">
          <div
            class="modal-bg"
            @click="handleCloseBulkUploadModal"
          ></div>
          <div class="d-flex flex-column modal-inner p-4">
            <div class="d-flex align-items-center mb-5">
              <h4 class="mr-2">
                Bulk Asset Upload
              </h4>
              <div class="text-muted">
                Please upload as a single .zip file
              </div>
            </div>
            <div class="d-flex flex-column align-items-start">
              <input data-id="bulk-asset-file" type="file" ref="bulk" accept=".zip" class="mb-2" />
            </div>
            <div class="d-flex flex-column align-items-start">
              <label for="private">Private</label>
              <input type="checkbox"
                name="private"
                data-id="bulk-asset-private"
                style="width: 38px; height: 38px;"
                v-model="bulkUploadModal.private"
                class="mb-2 form-control form-private"
              />
            </div>
            <div v-if="this.uiStates.bulkUploadModalWarning" class="text-danger mb-2">
              Bulk upload warning message
            </div>
            <button data-id="bulk-asset-submit" class="btn my-2 btn-primary" :disabled="loading" @click="handleBulkUpload()">
              Submit
            </button>
          </div>
        </div>
      </transition>
      <lightbox
        v-if="uiStates.lightbox"
        @lightbox-closed="handleCloseLightbox"
        :content="lightbox.content"
      ></lightbox>
      <div class="dataTables_wrapper container-fluid dt-bootstrap4">
        <list-view
          @lightbox-selected="handleAssetLightbox"
          :root="root"
          :currentFolder="currentFolder"
          :filter="filter"
          :paginate="perPage"
          :permissions="permissions"
          :features="features"
          v-if="listView"
          ref="listtable"
        ></list-view>
      </div>
    </div>
  </div>
</template>



<script>
import BasePagination from "../tables/base-pagination.vue";
import BasePaginationInfo from "../tables/base-pagination-info.vue";
import BaseFilterBar from "../tables/base-filter-bar.vue";
import BaseSelectVisible from '../tables/base-select-visible.vue';
import ListView from './asset-list-table.vue';
import Lightbox from './lightbox.vue';
import axios from 'axios'

const base_url = window.location.protocol + "//" + window.location.host;

export default {
  name: "dam-asset-list",
  components: {
    "base-pagination": BasePagination,
    "base-filter-bar": BaseFilterBar,
    "base-pagination-info": BasePaginationInfo,
    'base-select-visible': BaseSelectVisible,
    "list-view": ListView,
    "lightbox": Lightbox
  },
  props: {
    currentFolder: {
      required: false,
      type: [Object, String]
    },
    root: {
      required: false,
      type: Boolean
    },
    permissions: {
      required: false,
      type: [Object, Array]
    },
    features: {
      required: false,
      type: [Object, Array]
    }
  },
  mounted() {
    this.$events.$on('per-page', eventData => this.doVisibleSet(eventData))
    this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
    this.$events.$on('filter-reset', e => this.onFilterReset())
  },
  data() {
    return {
      perPage: 10,
      loading: false,
      listView: true,
      lightbox: {
        content: {},
      },
      uiStates: {
        errorMessage: null,
        showLoading: true,
        createAssetModal: false,
        bulkUploadModal: false,
        lightbox: false,
        createAssetModalWarning: false
      },
      bulkUploadModal: {
        private: false,
      },
      createAssetModal: {
        private: false,
        tags: ''
      },
      filter: '',
      moreParams: {},
      fields: [
        {
          name: "__slot:thumbnail-slot",
          title: "Thumbnail",
        },
        {
          name: "name",
          title: "Name",
        },
        {
          name: "size",
          title: "Size",
        },
        {
          name: "__slot:description-slot",
          title: "Description",
        },
        {
          name: "updated_at",
          title: "Updated",
          callback: "formatDate",
        },
        {
          name: "__slot:actions-slot",
          title: "",
        },
      ],
      css: {
        table: {
          tableClass: "table table-middle table-minimal",
          ascendingIcon: "sort-icon-asc",
          descendingIcon: "sort-icon-desc",
          infoClass: "",
        },
      },
      amountsShown: [
          { text: '10', value: 10 },
          { text: '25', value: 25 },
          { text: '50', value: 50 },
          { text: '100', value: 100 }
      ],
    };
  },
  computed: {
    apiURL() {
      return this.root ? 
        `${base_url}/pimapi/assets` : 
        `${base_url}/pimapi/assets/folder/${this.currentFolder.id}`;
    },
    currentTable() {
      return this.$refs.listtable;
    },
  },
  methods: {
    handleBulkUpload() {
      const file = this.$refs.bulk.files[0];
      
      let formData = new FormData();
      
      if (this.currentFolder.id) {
          formData.append('assetFolderId', this.currentFolder.id);
      }

      formData.append('file', file);
      formData.append('isPrivate', this.bulkUploadModal.private ? 1 : 0);

      this.loading = true;

      // todo: add actual endpoint, refactor & improve naming
      axios.post(base_url + '/pimapi/assets/bulk', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
          }
        ).then(function(response) {
            this.handleCloseBulkUploadModal();
            this.loading = false;

            this.$emit('alert', {
                message: 'Success, your bulk uploaded is being processed',
                status: "alert-success"
            });
        }.bind(this))
        .catch(function(error) {
            console.log(error);

            this.loading = false;
            this.handleCloseBulkUploadModal();
            
            if (error.response.status === 413) {
              this.$emit('alert', {
                  message: 'Upload too large, please upload a smaller .zip file',
                  status: "alert-danger"
              })
            } else {
              this.$emit('alert', {
                  message: error.response.data.message[0],
                  status: "alert-danger"
              })
            }
        }.bind(this));
    },
    handleUploadFiles() {
      let formData = new FormData();

      if (this.$refs.file.files.length > 20) {
        if (!this.uiStates.createAssetModalWarning) {
          this.uiStates.createAssetModalWarning = true;

          setTimeout(function() {
            this.uiStates.createAssetModalWarning = false;
          }, 15000)
        }
      } else {
        this.uiStates.createAssetModalWarning = false;

        for (let i = 0; i < this.$refs.file.files.length; i++) {
          const file = this.$refs.file.files[i];
          formData.append(`files_${i}`, file);
        }

        if (this.currentFolder.id) {
          formData.append('assetFolderId', this.currentFolder.id);
        }

        formData.append('isPrivate', this.createAssetModal.private ? 1 : 0);
        
      
        this.loading = true;

        axios.post(base_url + '/pimapi/assets', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
          }
        ).then(function(response) {
            this.currentTable.$refs.vuetable.refresh();
            this.handleCloseCreateAssetModal();

            this.loading = false;

            this.$emit('alert', {
                message: 'Success, asset(s) uploaded',
                status: "alert-success"
            });
        }.bind(this))
        .catch(function(error) {
            console.log(error);

            this.loading = false;
            this.handleCloseCreateAssetModal();
            
            if (error.response.status === 413) {
              this.$emit('alert', {
                  message: 'Upload too large, please use smaller file(s)',
                  status: "alert-danger"
              })
            } else {
              this.$emit('alert', {
                  message: error.response.data.message[0],
                  status: "alert-danger"
              })
            }
        }.bind(this));
      }
    },
    
    onChangePage (page) {
        this.$refs.vuetable.changePage(page)
    },
    doVisibleSet (perPageValue) {
        this.perPage = perPageValue;
    },
    onLoaded: function () {
      this.loading = false;
    },
    onFilterSet: _.debounce(function (e) {
      this.filter = e;
    }, 300),
    onFilterReset() {
      this.filter = '';
    },
    handleAssetLightbox(content) {
      this.lightbox.content = content;
      this.uiStates.lightbox = true;
    },
    handleCloseLightbox() {
      this.lightbox.content = '';
      this.uiStates.lightbox = false;
    },
    handleCloseBulkUploadModal() {
      this.$refs.bulk.value = null;
      this.uiStates.bulkUploadModalWarning = false;
      this.uiStates.bulkUploadModal = false;
    },
    handleCloseCreateAssetModal() {
      this.$refs.file.value = null;
      this.uiStates.createAssetModalWarning = false;
      this.uiStates.createAssetModal = false;
    }
  },
};
</script>

